// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2GOXT","content":"styles_content__1q3qc","checkbox":"styles_checkbox__2OjXJ","checkboxLabel":"styles_checkboxLabel__o-6rl"};